/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

export default [[["ਅੱਧੀ ਰਾਤ","ਸਵੇਰੇ","ਦੁਪਹਿਰੇ","ਸ਼ਾਮੀਂ","ਰਾਤੀਂ"],u,u],[["ਅੱਧੀ ਰਾਤ","ਸਵੇਰੇ","ਦੁਪਹਿਰੇ","ਸ਼ਾਮੀਂ","ਰਾਤੀਂ"],u,["ਅੱਧੀ ਰਾਤ","ਸਵੇਰੇ","ਦੁਪਹਿਰੇ","ਸ਼ਾਮ","ਰਾਤ"]],["00:00",["04:00","12:00"],["12:00","16:00"],["16:00","21:00"],["21:00","04:00"]]];
